import { Button, Col, Row, Typography } from 'antd';
import React from 'react';
import { useParams } from 'react-router';
import buskwarehousedetail from '../services/buskwarehousedetail';
// import busksellerdetail from "../services/busksellerdetail";

interface Props {
  totalWarehouse: number;
  selectedSellerContact: React.Key[];
}

const SellerContractList = ({
  totalWarehouse,
  selectedSellerContact
}: Props) => {
  const { id } = useParams<{ id: string }>();
  const handleOnExport = async () => {
    if (selectedSellerContact.length > 0) {
      const response = await buskwarehousedetail.exportSellerContractExcellById(
        id,
        selectedSellerContact
      );
      const outputFilename = `SellerContract_240406T9g6QGJSxyR.xlsx`;

      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    } else {
      const response = await buskwarehousedetail.exportSellerContractExcell(id);
      const outputFilename = `SellerContract_240406T9g6QGJSxyR.xlsx`;

      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    }
  };
  return (
    <div className="busk-sellerSubHead">
      <Row align="middle">
        <Col flex="auto">
          <Row gutter={15}>
            <Col>
              <Typography.Text>총 계약 셀러 {totalWarehouse}</Typography.Text>
            </Col>
            <Col>|</Col>
            <Col>
              <Typography.Text>
                선택 계약 셀러 {selectedSellerContact.length}
              </Typography.Text>
            </Col>
          </Row>
        </Col>
        <Col>
          <Button
            style={{
              color: 'gray'
            }}
            onClick={() => handleOnExport()}
          >
            엑셀 다운로드
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default SellerContractList;
